import loadable from '@loadable/component';
import { PageLoading } from "@tawn33y/gigsflow-core";

const Contact = loadable(() => import('@tawn33y/gigsflow-core/dist/pages/Contact/Contact'), {
  resolveComponent: (components) => components.Contact,
  fallback: (
    <PageLoading
      title="Contact us"
      description="Spotted an error in event details? Have a suggestion? Want to post an event? We'd love to hear from you!"
      url="https://gisflow.com/contact"
    />
  ),
});

export default function ContactPage() {
  return <Contact />
}
